import { t } from 'i18next';
import * as yup from 'yup';

export const prospectQuoteSchema = () =>
  yup.object({
    companyName: yup.string().trim().label(t('labelCompanyName')).required(),
    email: yup.string().trim().label(t('labelEmail')).email().required(),
    firstName: yup.string().trim().label(t('labelFirstName')).required(),
    lastName: yup.string().trim().label(t('labelLastName')).required(),
  });
